import React, { useEffect, useState, useRef } from 'react';

// Props: images -> array of filenames (located in public/office)
// Renders images as <img> elements and preloads all before auto-rotation
export default function HeroSlideshow({ images = [], interval = 4500 }) {
  const [index, setIndex] = useState(0);
  const [allLoaded, setAllLoaded] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!images || images.length === 0) return;
    let cancelled = false;
    const urls = images.map((name) => `${process.env.PUBLIC_URL}/office/${encodeURIComponent(name)}`);
    const loaders = urls.map((url) =>
      new Promise((res) => {
        const img = new Image();
        img.onload = () => res(true);
        img.onerror = () => res(true);
        img.src = url;
      })
    );
    Promise.all(loaders).then(() => {
      if (!cancelled) setAllLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, [images]);

  useEffect(() => {
    if (!allLoaded || images.length === 0) return;
    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, interval);
    return () => clearInterval(timerRef.current);
  }, [allLoaded, images.length, interval]);

  if (!images || images.length === 0) return null;

  return (
    <div className="relative w-full h-full" aria-hidden>
      {images.map((name, i) => {
        const visible = i === index;
        const url = `${process.env.PUBLIC_URL}/office/${encodeURIComponent(name)}`;
        return (
          <img
            key={name}
            src={url}
            alt=""
            loading="eager"
            decoding="async"
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${visible ? 'opacity-100 z-10' : 'opacity-0 z-0 slideshow-slide'}`}
          />
        );
      })}
      {/* overlay for subtle gradient to keep text readable */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-white/70 pointer-events-none" />
    </div>
  );
}
